<template>
  <div class="rect-loading loading-mask" :style="{ background: background }">
    <div class="loading-spinner">
      <div class="spinner">
        <div class="rect1" :style="{ background: rectBackground }"></div>
        <div class="rect2" :style="{ background: rectBackground }"></div>
        <div class="rect3" :style="{ background: rectBackground }"></div>
        <div class="rect4" :style="{ background: rectBackground }"></div>
        <div class="rect5" :style="{ background: rectBackground }"></div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  data () {
    return {

    }
  },
  props: {
    background: {
      type: String,
      default: null
    },
    rectBackground: {
      type: String,
      default: null
    }
  },
  computed: {

  },
  created () {

  },
  methods: {

  }
}
</script>

<style lang="scss" scoped>
// style already in public/index.html
</style>
